import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectExportSlides = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.exportSlides
)
